import { useState } from "react";
import { Button, Input} from "./ui";
import {ApiCalls} from "./apiCalls"
import "../blueprintSrc/styles/main.css"

const LogIn = (props)=>{
    const [apiCaller] = useState(new ApiCalls());

    // event listener for the log in
    apiCaller.addEventListener("EVENT_LOG_IN", ()=>{
        handleLogIn();
    });

    // check if token is is valid
    console.log("LOG IN");
    if(apiCaller.getToken() !== undefined){
        let date = new Date(apiCaller.getExpirationDate());
        let now = new Date();

        if(now < date){
            //apiCaller.refresh();
            props.logInHandler(apiCaller.getToken());
        }
    }

    const handleLogIn = ()=>{
       props.logInHandler(apiCaller.getToken());
    }

    const handleClick = ()=>{
        apiCaller.getBearerToken()
    }

    let style = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }

    return (
        <div id="login_screen">
            <div className="login-block">
                <img src={"./compass_lowres.png"} width="300" height="300" />
                <Input placeholder="username" id="username"/>
                <Input id="password" type="password" placeholder="password" />
                <div style={style}>
                    <Button onClick={handleClick}> Login</Button>
                </div>
                <div id="login_div"></div>
            </div>
        </div>
    ); 
}

export default LogIn;